import { makeStyles } from 'tss-react/mui';

export const useHangUpStyles = makeStyles()((theme) => ({
  container: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: `${theme.spacing(5)} 0 auto`,
    padding: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      margin: '0 auto'
    }
  },
  infoCard: {
    maxWidth: '505px',
    width: '100%',
    margin: '32px 0',
  },
  buttonSection: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      maxWidth: '260px',
    },
    [theme.breakpoints.down('md')]: {
      '& button': {
        height: '36px',
      }
    }
  },
  fullWidth: {
    width: '100%',
  },
}));
